<template>
    <el-form-item :label="config.label" :prop="config.name">
        <el-input v-model="config.value" v-if="config.type === 'input'"></el-input>
        <RemoteSelect v-model="config.value" :url="config.url" :options="config.options" v-else-if="config.type === 'select'"></RemoteSelect>
        <el-date-picker v-model="config.value" v-else-if="config.type === 'datetimerange'"
                        type="datetimerange" range-separator="~" :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-date-picker v-model="config.value" v-else-if="config.type === 'daterange'"
                        type="daterange" range-separator="~"
                        value-format="yyyy-MM-dd"></el-date-picker>
    </el-form-item>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'

    export default {
        components: {
            RemoteSelect,
        },
        props: ["config"]
    }
</script>